import React from 'react';
import { PendingIcon } from '../../../assets';

function AfterSubmitionMsg() {
  return (
    <div style={{display: 'flex', alignItems: 'center', flexDirection: "column"}}>
      <div style={{width: "200px", height: "200px"}}>
        <PendingIcon style={{width: "100%", height: "100%"}} />
      </div>
      <div>
        <p style={{textAlign: "center"}}>
          Your claim request is in progress, we will get back to you within two working days. If you have any additional questions, please contact support@sommly.com.
        </p>
      </div>
    </div>
  )
}

export default AfterSubmitionMsg;
